import useActionsStore from "stores/useActionsStore";

// Completed actions stay in the live list for 30 days after completion.
// Older ones load page by page (useActionHistory).
export const LIVE_COMPLETED_DAYS = 30;

export const getLiveCompletedCutoff = (now = Date.now()) =>
  new Date(now - LIVE_COMPLETED_DAYS * 24 * 60 * 60 * 1000);

// The same cutoff for the whole session of one account. A listener restart
// reuses it, so no action falls between the live list and the history.
export const getSessionCutoff = (uid) => {
  const { liveCutoff, setLiveCutoff } = useActionsStore.getState();
  if (liveCutoff?.uid === uid) return liveCutoff.date;
  const date = getLiveCompletedCutoff();
  setLiveCutoff({ uid, date });
  return date;
};
